<section class="bio">
    <div class="bio-photo"><img *ngIf="photo" id="bio-picture" src="{{photo}}"></div>
    <div class="bio-text" *ngIf="textList">
        <p *ngFor="let line of textList">{{line}}</p>
    </div>
</section>
